'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'party-horn';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e31b';
var svgPathData = ['M17 474.4c-4.6 12.4 8.3 25.3 20.6 20.6l91.7-34.4L51.4 382.7 17 474.4zM57.6 366.3l88.2 88.2 76.6-28.7L86.3 289.6 57.6 366.3zm34.8-92.9c.4 .3 .9 .6 1.2 1l144 144c.4 .4 .7 .8 1 1.3l55.2-20.7c10.5-3.9 13.7-18.4 5.7-26.3L139.4 212.5c-8-8-22.4-4.8-26.3 5.7L92.4 273.3z', 'M163.1 145.7c-3.5 2.7-4.1 7.7-1.4 11.2s7.7 4.1 11.2 1.4l6.2-4.8c43.7-34 71.4-84.6 76.4-139.8l.5-5c.4-4.4-2.8-8.3-7.2-8.7s-8.3 2.8-8.7 7.2l-.5 5C235 63 209.5 109.6 169.3 140.9l-6.2 4.8zM48 32a16 16 0 1 1 32 0A16 16 0 1 1 48 32zm48 0A32 32 0 1 0 32 32a32 32 0 1 0 64 0zM17 474.4l34.4-91.7 77.9 77.9L37.7 495c-12.4 4.6-25.3-8.3-20.6-20.6zm128.7-19.9L57.6 366.3l28.7-76.6L222.4 425.7l-76.6 28.7zM93.7 274.3c-.4-.4-.8-.7-1.2-1l20.7-55.1c3.9-10.5 18.4-13.7 26.3-5.7L299.5 372.6c8 8 4.8 22.4-5.7 26.3l-55.2 20.7c-.3-.4-.6-.9-1-1.3l-144-144zm57.1-73.2c-16.2-16.2-44.6-10-52.6 11.4L2 468.8c-9.5 25.2 16 50.7 41.2 41.2l256.2-96.1c21.4-8 27.6-36.4 11.4-52.6L150.7 201.2zM480 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM355.1 350.3c3.5 2.7 8.5 2.1 11.2-1.4l21.9-28.1c20.4-26.2 50.8-42.8 83.9-45.8l32.7-3c4.4-.4 7.6-4.3 7.2-8.7s-4.3-7.6-8.7-7.2l-32.7 3c-37.5 3.4-71.9 22.2-95 51.9l-21.9 28.1c-2.7 3.5-2.1 8.5 1.4 11.2zM509.3 14c3.3-2.9 3.6-8 .7-11.3s-8-3.6-11.3-.7L481.9 16.8c-9.5 8.4-21.9 12.9-34.6 12.5c-33.2-.9-62 23-67.2 55.9l-6.9 43.9c-4.7 30.1-29.6 52.9-59.9 55.1c-17.2 1.3-33.5 7.9-46.7 19.1l-7.7 6.6c-3.4 2.9-3.8 7.9-.9 11.3s7.9 3.8 11.3 .9l7.7-6.6c10.6-8.9 23.7-14.3 37.5-15.3c37.8-2.8 68.6-31.2 74.6-68.6l6.9-43.9c3.9-24.9 25.7-43 51-42.4c16.7 .5 33-5.5 45.6-16.5L509.3 14z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPartyHorn = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;